import { useMemo } from 'react';
import { ChatOptionsProps } from '../ChatOptions.types';
import { StrategyAgentV2Options as StrategyOptions } from './StrategyAgentOptions.types.ts';
import { useOptionsManager } from '../hooks/useOptionsManager';
import { DEFAULT_SELECTABLE_MODEL, useAgentModelOptions } from '../hooks/useAgentModelOptions';

const getDefaultOptions = ({
  selectedValue,
}: Pick<StrategyOptions, 'selectedValue'>): StrategyOptions => ({
  selectedValue,
});

const transformStrategyOptions = (options: StrategyOptions) => ({
  llmOptions: { model: options.selectedValue },
});

function fromStoreStrategyOptions(
  storedOptions: Record<string, unknown> | undefined,
  defaultOptions: StrategyOptions,
): StrategyOptions {
  const llmOptions = storedOptions?.llmOptions as { model?: string } | undefined;
  return { selectedValue: llmOptions?.model ?? defaultOptions.selectedValue };
}

export const StrategyAgentOptions = ({ onOptionUpdated }: ChatOptionsProps) => {
  const filteredModels = useAgentModelOptions();

  const defaultOptions = useMemo(() => {
    const firstModel = filteredModels[0]?.value ?? DEFAULT_SELECTABLE_MODEL;
    return getDefaultOptions({ selectedValue: firstModel });
  }, [filteredModels]);

  useOptionsManager({
    defaultOptions,
    onOptionUpdated,
    toStore: transformStrategyOptions,
    fromStore: fromStoreStrategyOptions,
  });

  // The model is shown in the right-side AI Model Selector, so this popup is empty.
  return null;
};
